import React, { Component } from 'react';
import * as d3 from 'd3';

import ImgPointer from '../images/pointer.png';

import VillagerAvatar from '../components/VillagerAvatar';
import Button from '../components/Button';
import Dialogue from '../components/Dialogue';
import PersonalityAvatar from '../components/PersonalityAvatar';
import TipBubble from '../components/TipBubble';

import ChartSpecs from '../data/chart_specs';

const unsortedObj = ChartSpecs.chartspecs.colorWheelObjPersonality
const sortObject = o => Object.keys(o).sort((a,b)=>a.localeCompare(b)).reduce((r, k) => (r[k] = o[k], r), {})
const colorWheelObj = sortObject(unsortedObj);
const colorWheelArray = Object.keys(colorWheelObj)
const colorRange = Object.values(colorWheelObj);
const margin = ChartSpecs.chartspecs.margin;
const areaMargin = ChartSpecs.chartspecs.marginAreabars;


var popularPersonalities = ['Normal', 'Peppy', 'Lazy', 'Sisterly'];
var unpopularPersonalities = ['Snooty', 'Cranky', 'Jock', 'Smug'];

class VillagerPersonality extends Component {
  constructor(props){
      super(props);
      this.state = {
        chartType: "viewbyAreaH",
        selectedTier:1,
        selectedUnPopularTier:10,
      }
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};

      this.sliderRangeHandler = this.sliderRangeHandler.bind(this);

   }
   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);

     this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => d.personality);
     this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => d.personality);
     this.tierArray = [...this.tierNodes2.keys()];

     this.drawAreaStackChartH();

     this.drawChart(popularPersonalities, 'popularPersonalityChart');
     this.drawChart(unpopularPersonalities, 'unPopularPersonalityChart');

   }

   drawAreaStackChartH(){
        var svg = this.svg,
            chartWidth = this.svgRef.current.clientWidth,
            chartHeight = 460,
            stackKeys = colorWheelArray,
            radius = 40;


        let tierNodes = this.tierNodes,
             tierNodes2 = this.tierNodes2,
             tierArray = this.tierArray;

        let tableData = Array.from(tierNodes2.entries())
        .map(g => {
          const obj = {};
          obj["tier"] = g[0];
          for (let col of stackKeys) {
            const vals = g[1].get(col);
            //console.log("vals: "+vals);
            obj[col] = !vals ? 0 : vals;
          }
          return obj;
        })
       .sort((a, b) => a["tier"] - b["tier"]);


        const xScale = d3.scaleBand()
              .domain(tierArray)
              .range([margin.left, chartWidth + margin.right])
              .paddingOuter(0.25)

             // .padding(0.25)

        const yScale= d3.scaleLinear()
                      .range([chartHeight - margin.top, margin.top])
                      // .range([ chartHeight/totalBarGroups - margin.top, margin.top/totalBarGroups])


        const colorScale = d3.scaleOrdinal()
                    .domain(colorWheelArray)
                    .range(colorRange)

        const yAxis = g => g
                    .attr("transform", `translate(${margin.left},0)`)
                    .call(d3.axisLeft(yScale).ticks(chartWidth / 100, "%"))
                    .call(g => g.selectAll(".domain").remove());

        const xAxis = g => g
                  .attr("transform", `translate(${-margin.left/2},${ chartHeight - margin.top/1.25})`)
                   //.attr("transform", `translate(0,${margin.top+10})`)
                  .call(d3.axisBottom(xScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                  .call(g => g.selectAll(".domain").remove())



                const formatPercent = d3.format(".1%");
                const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")

                  // Creating the clone of the array
                  let clonetableData = tableData.slice(0);

                  const clonetableDataArr = tableData.map(d => ({ ...d}));

                  // Extract the array using splice method
                  let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

                  const clonetableDataFirst = tableDataExtended[0];
                  const clonetableDataLast = tableDataExtended[tierArray.length-1];

                  //let tableDataExtended = tableData.slice();

                  tableDataExtended.unshift(clonetableDataFirst);
                  tableDataExtended.push(clonetableDataLast);

                  let newFirst = tableDataExtended[0],
                      newLast = tableDataExtended[tableDataExtended.length-1];


                const series = d3.stack()
                              .keys(stackKeys)
                              .offset(d3.stackOffsetExpand)
                            (tableDataExtended)
                              .map(d => (d.forEach(v => v.key = d.key), d))

        svg.attr("id", 'personalityChart');
        svg.attr("height", chartHeight);

        svg.append("g")
        .attr("class", 'xaxis tier-axis')
        .call(xAxis);

        svg.append("g")
        .attr("class", 'yaxis')
        .call(yAxis);

        // define the area
        let area = d3.area()
            .y0(d => yScale(d[0]))
            .y1(d => yScale(d[1]))
            .x((d,i) => {
              if(i === 0){
                return xScale.bandwidth()/2 + margin.left/2
              }else if(i === (tableDataExtended.length-1)){
                return  xScale(d.data.tier) + xScale.bandwidth()/2
              }else{
                return  xScale(d.data.tier)
              }
            })
            //.y0(yScale(0))
            //.y(d => yScale(d.data.tier))
            .curve(d3.curveBasis)


       let layer = svg.append("g")
             .selectAll(".layer")
             .data(series)
            .join("g")
             .attr("class", "layer")
             .attr("transform", `translate(${0}, ${0})`);

       layer.append("path")
             .attr("class", "area-personality")
             .attr("fill", d => colorScale(d.key))
             .attr("d", area);


       layer.append("text")
            .attr("class", "area-label")
            .filter(d => (d.key === 'Normal' || d.key === 'Snooty'))
            .attr("x", d => (d.key === 'Normal')?margin.left*1.5:(chartWidth-margin.left*2))
            .attr("y", d => (d.key === 'Normal')?(yScale(d[2][1])+((yScale(d[3][0]) - yScale(d[2][1]))/2)):(yScale(d[10][1])+((yScale(d[10][0]) - yScale(d[10][1]))/2)) )
            .attr("dy", "0")
            .text(d => d.key)
            .attr("fill", d => (d.key === 'Normal')?'#333333':'#ffffff')

      }

   drawChart(selectedPersonality, svgId){

     let svg = d3.select(`#${svgId}`);

     var chartWidth = svg.node().getBoundingClientRect().width,
         singleChartHeight = 40,
         stackKeys = selectedPersonality,
         radius = 40,
         strokeColor = 'rgba(1,124,116,1)',
         fillColor = 'rgba(1,124,116,0.5)',
         fillColorLight = 'rgba(1,124,116,0.1)',
         totalBarGroups = selectedPersonality.length,
         noOfColumns = 2;

         //svg.attr("id", 'popularPersonalityChart');
         //svg.attr("height", chartHeight+margin.top);

         // Add gradient defs to svg https://codepen.io/louisemoxy/pen/eQGVyQ
          const defs = svg.append("defs");

          const gradient = defs.append("linearGradient").attr("id", `svgGradient${svgId}`);
          const gradientResetPercentage = "50%";

          gradient
            .append("stop")
            .attr("class", "start")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColorLight);

          gradient
            .append("stop")
            .attr("class", "start")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColor);

          gradient
            .append("stop")
            .attr("class", "end")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColor)
            .attr("stop-opacity", 1);

          gradient
            .append("stop")
            .attr("class", "end")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColorLight);


     let  tierNodes2 = this.tierNodes2,
          tierArray = this.tierArray,
          noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);

      let chartHeight = singleChartHeight*totalBarGroups;

      svg.attr("height", chartHeight + areaMargin.top);

       this.dataSet = Array.from(tierNodes2.entries())
        .map(g => {
          const obj = {};
          obj["tier"] = g[0];
          for (let col of stackKeys) {
            const vals = g[1].get(col);
            obj[col] = !vals ? 0 : vals;
          }
          return obj;
        })
       .sort((a, b) => a["tier"] - b["tier"]);


       let tableData = this.dataSet;

       const yMaxArray = stackKeys.map(personality => {
         let max = d3.max(tableData, d => d[personality])
         return max;
       });



        const yMax = d3.max(yMaxArray, d => d);


        const xScale = d3.scaleBand()
                        .domain(tierArray)
                        .range([areaMargin.left, chartWidth/noOfColumns - areaMargin.right])
                        //.padding(0.5)

        const yScale = d3.scaleLinear()
                        .domain([ 0, yMax]) //to maintain the same chartHeight, force the domain range to match the popularSpeices chart
                        .range([singleChartHeight, areaMargin.top/singleChartHeight]);

        const xAxis = g => g
                    .call(d3.axisBottom(xScale).tickFormat((d,i) => {
                     return (i%9 !== 0)  ? " ": `T.${d}` ;
                    }).tickSizeOuter(0))
                    .call(g => g.selectAll(".domain").remove());

        const yAxis = g => g
                  .call(d3.axisLeft(yScale).ticks(2).tickSizeOuter(0).tickFormat(y => `${y.toFixed(0)}`))
                  .call(g => g.selectAll(".domain").remove());

        // Creating the clone of the array
        let clonetableData = tableData.slice(0);

        const clonetableDataArr = tableData.map(d => ({ ...d}));

        // Extract the array using splice method
        let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

        const clonetableDataFirst = tableDataExtended[0];
        const clonetableDataLast = tableDataExtended[tierArray.length-1];

        //let tableDataExtended = tableData.slice();

        tableDataExtended.unshift(clonetableDataFirst);
        tableDataExtended.push(clonetableDataLast);

        let newFirst = tableDataExtended[0],
            newLast = tableDataExtended[tableDataExtended.length-1];

        stackKeys.forEach((personality, index) => {

          // define the area
          let area = d3.area()
              //.x(d => xScale(d.tier))
              .x((d,i) => {
                if(i === 0){
                  return xScale.bandwidth()/2 + areaMargin.left/2
                }else if(i === (tableDataExtended.length-1)){
                  return xScale(d.tier) + xScale.bandwidth()/2
                }else{
                  return xScale(d.tier)
                }
              })
              .y0(yScale(0))
              .y1(d => yScale(d[personality]))
              //.y1(d => d.tier === "Start" ? yScale(d[sign]) : yScale(d[sign]))
              .curve(d3.curveStep)

          // define the line
          let line = d3.line()
                    //.x(d => xScale(d.tier))
                    .y(d => yScale(d[personality]))
                    .x((d,i) => {
                      if(i === 0){
                        return xScale.bandwidth()/2 + areaMargin.left/2
                      }else if(i === (tableDataExtended.length-1)){
                        return xScale(d.tier) + xScale.bandwidth()/2
                      }else{
                        return xScale(d.tier)
                      }
                    })
                    //.y(d => d.tier === "Start" ? yScale(d[firstSign]) : yScale(d[sign]))
                    .curve(d3.curveStep)



         let group = svg.append("g")
           .attr('class', `path-${personality}`); //add dash in Bear cub to generate right class name
         let barLabels = svg.append("g")
             .attr('class', `bar-label-${personality}`)

         let chartLabels = svg.append("g")
             .attr('class', `chart-label-${personality}`)


         // Add the area
         group.append('path')
             .datum(tableDataExtended)
             .attr('class', `path-goodlooking`)
             //.style('fill', fillColorLight)
             .style('fill', `url(#svgGradient${svgId})`)
             .attr("d",area)


         chartLabels.append('text')
             .attr('class', 'chart-label')
             .attr("x", d => 0)
             .attr('y', d => yScale(yMax/2))
             .attr("dy", "0em")
             .text(d => `${personality}`);

        // Add the line
         group.append("path")
            .datum(tableDataExtended)
            .attr("fill", "none")
            .attr("stroke", strokeColor)
            .attr("stroke-width", 2)
            .attr("d", line)

               if(index < noOfChartsPerCol){
                 svg.append("g")
                 .attr("transform", `translate(${-areaMargin.right/6}, ${chartHeight- areaMargin.top/4})`)
                 .attr("class", 'xaxis tier-axis no-tick gap-tick')
                 .call(xAxis);

                 svg.append("g")
                 .attr("transform", `translate(${areaMargin.left/1.25}, ${areaMargin.top/noOfColumns + index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4})`)
                 .attr("class", 'yaxis')
                 .call(yAxis);



                 if(svgId ==='popularPersonalityChart'){
                    chartLabels.attr("transform", `translate(${chartWidth/noOfColumns - areaMargin.right}, ${(areaMargin.top/10)+ index*(chartHeight/noOfChartsPerCol) + index*areaMargin.top/4}) rotate(0)`)
                    .attr("text-anchor", "end")
                 }else{
                    chartLabels.attr("transform", `translate(${areaMargin.right}, ${(areaMargin.top/10)+ index*(chartHeight/noOfChartsPerCol) + index*areaMargin.top/4}) rotate(0)`)
                    .attr("text-anchor", "start")
                 }


                 group.attr("transform", `translate(${0  + areaMargin.right/6}, ${areaMargin.top/2 + index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4})`)

                 barLabels.attr("transform", `translate(${chartWidth/noOfColumns - areaMargin.right/2.25}, ${areaMargin.top/1 + index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4}) rotate(0)`)

               }else{
                 svg.append("g")
                 .attr("transform", `translate(${chartWidth/noOfColumns-areaMargin.right/6}, ${chartHeight- areaMargin.top/4})`)
                 .attr("class", 'xaxis tier-axis no-tick gap-tick')
                 .call(xAxis);

                svg.append("g")
                 .attr("transform", `translate(${chartWidth/noOfColumns + areaMargin.left/1.25}, ${areaMargin.top/noOfColumns + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4})`)
                 .attr("class", 'yaxis')
                 .call(yAxis);


                if(svgId ==='popularPersonalityChart'){
                   chartLabels.attr("transform", `translate(${chartWidth - areaMargin.right}, ${(areaMargin.top/10) + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4}) rotate(0)`)
                   .attr("text-anchor", "end")

                }else{
                   chartLabels.attr("transform", `translate(${chartWidth/noOfColumns + areaMargin.right}, ${(areaMargin.top/10) + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4}) rotate(0)`)
                   .attr("text-anchor", "start")
                }


                 group.attr("transform", `translate(${chartWidth/noOfColumns + areaMargin.right/6}, ${areaMargin.top/2 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4})`)

                 barLabels.attr("transform", `translate(${chartWidth - areaMargin.right/2.25}, ${areaMargin.top/1 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4}) rotate(0)`)

               }

         });
         if(svgId ==='popularPersonalityChart'){
            this.highlightTierBar(this.state.selectedTier, svgId);
         }else{
            this.highlightTierBar(this.state.selectedUnPopularTier, svgId);
         }
   }

   sliderRangeHandler(event, chartId){
      let selectedTier = event.target.value;

      if(chartId ==='popularPersonalityChart'){
         this.setState({selectedTier: selectedTier});
      }else{
        this.setState({selectedUnPopularTier: selectedTier});
      }

      this.highlightTierBar(selectedTier, chartId);
   }

   highlightTierBar(selectedTier, chartId){
     let tableData = this.dataSet,
         tierArray = this.tierArray,
         totalBarGroups = colorWheelArray.length,
         stackKeys=colorWheelArray,
         noOfColumns = 2;

     let svg = d3.select(`#${chartId}`);
     let chartHeight = svg.node().getBoundingClientRect().height,
         chartWidth = svg.node().getBoundingClientRect().width;

     let noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);


     const yMaxArray = stackKeys.map(sign => {
       let max = d3.max(tableData, d => d[sign])
       return max;
     });

      const yMax = d3.max(yMaxArray, d => d);


     const xScale = d3.scaleBand()
                     .domain(tierArray)
                     .range([0, chartWidth/noOfColumns - areaMargin.right])
                     //.padding(0.5)

     const yScale = d3.scaleLinear()
                     .domain([ 0, yMax])
                     .range([chartHeight/noOfChartsPerCol - areaMargin.top, areaMargin.top/noOfChartsPerCol])


      // Get the index of the xValue relative to the dataSet
      const dataIndex = tableData.findIndex(obj => obj.tier === Number(selectedTier))

    //  const leftData = (dataIndex === 0)? 0 :tableData[dataIndex-1];
      const leftData = tableData[dataIndex];
      const rightData = (dataIndex === 9)? 'max':tableData[dataIndex + 1];

      //d3.select('.year1').text(`${leftData.year} : ${leftData.popularity}`)
      //d3.select('.year2').text(`${rightData.year} : ${rightData.popularity}`)

      if(rightData === 'max'){
          svg.selectAll(".start").attr("offset", `${90}%`);
          svg.selectAll(".end").attr("offset", `${100}%`);
        }else{
          // Update gradient
          const x1Percentage = xScale(leftData.tier) / (chartWidth/noOfColumns - areaMargin.right)  * 100;
          const x2Percentage = xScale(rightData.tier) / (chartWidth/noOfColumns - areaMargin.right)  * 100;
          svg.selectAll(".start").attr("offset", `${x1Percentage}%`);
          svg.selectAll(".end").attr("offset", `${x2Percentage}%`);
        }
   }

  render() {
    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-traits">
        <h2 className="title">Villager personality</h2>
        <p className="paragraph">Every villager has a personality type that influences how they talk and behave.  We wanted to know whether there are certain personality types that are more favored by players.</p>
        <p className="paragraph">
        There are eight different personality types total. From the personality distribution chart below, and from looking at our top 40 villagers to the left, the personality types do exhibit some clear trends.
        </p>
        <ul className={`chart-key-list long-list personality-list`}>
          {colorWheelArray.map(list => {
              return (
                <li key={list}>
                  <PersonalityAvatar personality={list} personalityColor={colorWheelObj[list]}/>
                </li>
              )
          })}
        </ul>
        <svg ref={this.svgRef} width="100%"></svg>
        <p className="paragraph space-top-sm">
        The strongest trend here is the <b>Normal</b> villagers, who make up around <b>30%</b> of both Tier 1 and Tier 2, dropping down to <b>10%</b> for most of Tiers 4-10.
        </p>
        <div className='space-bottom space-top-sm space-bottom-sm'>
        <TipBubble>You can <img className="cursor-pointer" alt='pointer' src={ImgPointer}/> <b>drag the slider</b> below to compare the number of villagers within a specific tier.</TipBubble>
        </div>
        <div className='tier-slider'>
            <label htmlFor="personalityTierSlider" className='slider-label' aria-label="Tier slider"></label>
            <input type="range"
            id="personalityTierSlider"
            min="1"
            max="10"
            value={this.state.selectedTier}
            onChange={(e) => this.sliderRangeHandler(e,'popularPersonalityChart')}
            step="1"
            className='slider-input'/>
            <output htmlFor="personalityTierSlider" id="personalityTierSlider-output" style={{left: `calc(${parseInt(this.state.selectedTier)*10}% - ${(parseInt(this.state.selectedTier)/10)*72}px - ${3.9*(10-parseInt(this.state.selectedTier))}px)`}} className='slider-output'>Tier {this.state.selectedTier}</output>
        </div>
        <svg id='popularPersonalityChart' width="100%"></svg>
        <p className="paragraph space-bottom"> Though the trends are not as pronounced, <b>Peppy</b>, <b>Lazy</b>, and <b>Sisterly</b> villagers also seem to appear more in the higher tiers. </p>

        <p className="paragraph space-top"> On the other end of the spectrum, there is a big spike in <b>Snooty</b> characters in the lower tiers, especially in Tier 9, where <b>33%</b> of villagers are <b>Snooty</b>.</p>
        <div className='tier-slider'>
            <label htmlFor="unpersonalityTierSlider" className='slider-label' aria-label="Tier slider"></label>
            <input type="range"
            id="unpersonalityTierSlider"
            min="1"
            max="10"
            value={this.state.selectedUnPopularTier}
            onChange={(e) => this.sliderRangeHandler(e,'unPopularPersonalityChart')}
            step="1"
            className='slider-input'/>
            <output htmlFor="unpersonalityTierSlider" id="unpersonalityTierSlider-output" style={{left: `calc(${parseInt(this.state.selectedUnPopularTier)*10}% - ${(parseInt(this.state.selectedUnPopularTier)/10)*72}px - ${3.9*(10-parseInt(this.state.selectedUnPopularTier))}px)`}} className='slider-output'>Tier {this.state.selectedUnPopularTier}</output>
        </div>
        <svg id='unPopularPersonalityChart' width="100%"></svg>
        <p className="paragraph space-bottom">The remaining personality types, <b>Cranky</b>, <b>Jock</b>, and <b>Smug</b>, also tend to have more villagers in Tiers 6-10 than they do in Tiers 1-5. </p>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph"> Based on these trends, <b>Normal</b>, <b>Peppy</b>, <b>Lazy</b>, and <b>Sisterly</b> villagers tend to be more popular, whereas <b>Snooty</b>, <b>Cranky</b>, <b>Jock</b>, and <b>Smug</b> villagers tend to be less popular. </p>
        <p className="paragraph"> In Animal Crossing, personality types are subsets of a villager’s gender. <b>Normal</b>, <b>Peppy</b>, and <b>Sisterly</b> are 3 out of the 4 female personalities, so we can also make an additional observation that female villagers tend to be more popular than male villagers. </p>
        </Dialogue>

      </div>
    )
  }
}

export default VillagerPersonality;
